export default __webpack_public_path__ + "static/media/minotaur-white.a2a26fbc.svg";